import F2FVideoPage from "../../../pages/F2F/F2FVideo/F2FVideoPage";

const F2FVideoCall = () => {
  return (
    <>
      <F2FVideoPage />
    </>
  );
};

export default F2FVideoCall;
